import { CaretRight } from '@phosphor-icons/react';
import { withMagneticIcon } from '../withMagneticIcon.js';

const Icon = withMagneticIcon(CaretRight);
Icon.displayName = "CaretRight";

export { Icon as CaretRight };
//# sourceMappingURL=CaretRight.js.map
